<template>
    <div>
        <b-form-group :label="component.properties.label" class="mb-0">
            <template v-if="component.type === 'text'">
                <el-input :value="modelValue" @input="$emit('input', $event)"
                    :placeholder="component.properties.placeholder" :maxlength="component.properties.maxlength"
                    size="small" show-word-limit />
            </template>

            <template v-else-if="component.type === 'textarea'">
                <el-input :value="modelValue" @input="$emit('input', $event)" type="textarea"
                    :placeholder="component.properties.placeholder" :rows="component.properties.rows"
                    :maxlength="component.properties.maxlength" size="small" show-word-limit />
            </template>

            <template v-else-if="component.type === 'select'">
                <div class="d-flex align-items-center w-100">
                    <el-select :value="modelValue" @input="$emit('input', $event)" size="small" filterable clearable
                        :placeholder="component.properties.placeholder" class="flex-grow-1">
                        <el-option v-for="option in component.properties.options" :key="option.id" :label="option.name"
                            :value="option.id" />
                    </el-select>
                    <el-tooltip effect="dark" placement="top" popper-class="py-1 px-2" content="Agregar más opciones">
                        <b-button v-if="component.properties.addOptions" variant="success" class="ml-2 p-1"
                            @click="modalCreateSubCategory = true">
                            <i class="fa fa-plus"></i>
                        </b-button>
                    </el-tooltip>
                </div>
            </template>

            <template v-else-if="component.type === 'multiselect'">
                <div class="d-flex align-items-center w-100">
                    <el-select :value="modelValue" @input="$emit('input', $event)" multiple size="small" filterable
                        clearable :placeholder="component.properties.placeholder" class="flex-grow-1">
                        <el-option v-for="option in component.properties.options" :key="option.id" :label="option.name"
                            :value="option.id" />
                    </el-select>
                    <el-tooltip effect="dark" placement="top" popper-class="py-1 px-2" content="Agregar más opciones">
                        <b-button v-if="component.properties.addOptions" variant="success" class="ml-2 p-1"
                            @click="modalCreateSubCategory = true">
                            <i class="fa fa-plus"></i>
                        </b-button>
                    </el-tooltip>
                </div>
            </template>

            <template v-else-if="component.type === 'checkbox'">
                <el-radio-group :value="modelValue" @input="$emit('input', $event)" size="small">
                    <el-radio-button :label="1">SI</el-radio-button>
                    <el-radio-button :label="0">NO</el-radio-button>
                </el-radio-group>
            </template>

            <template v-else-if="component.type === 'date'">
                <el-date-picker :value="modelValue" @input="$emit('input', $event)" size="small" type="date"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="component.properties.placeholder"
                    style="width: 100%" />
            </template>

            <template v-else-if="component.type === 'number'">
                <div class="number-field-wrapper">
                    <el-input-number v-model="localValue" size="small" controls-position="right"
                        :min="component.properties.min" :max="component.properties.max" :step="1" style="width: 100%" />
                </div>
            </template>

            <template v-else-if="component.type === 'decimal'">
                <div class="number-field-wrapper">
                    <el-input-number v-model="localValue" size="small" controls-position="right"
                        :min="component.properties.min" :max="component.properties.max" :step="0.01" :precision="2"
                        style="width: 100%" />
                </div>
            </template>

            <div v-if="error" class="text-danger small mt-1">
                {{ error }}
            </div>
        </b-form-group>

        <b-modal v-model="modalCreateSubCategory" ok-only class="float-left" scrollable title="Agregar Opción">
            <b-form data-vv-scope="formCreateSubcategory">
                <b-form-group label="Nombre" label-for="nameSubcategory">
                    <b-form-input id="nameSubcategory" name="nameSubcategory" v-model="nameSubcategory"
                        placeholder="Nombre de la opción nueva" v-validate="'required'" data-vv-as=" "
                        @input="nameSubcategory = nameSubcategory.toUpperCase()" />
                    <span class="text-danger span-error small"
                        v-text="errors.first('formCreateSubcategory.nameSubcategory')" />
                </b-form-group>
            </b-form>
            <template #modal-footer>
                <b-button variant="danger" @click="cancelSubCategory">Cancelar</b-button>
                <b-button variant="primary" @click="saveSubCategory">Guardar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: "DynamicField",
    props: {
        component: {
            type: Object,
            required: true
        },
        modelValue: {
            type: [String, Number, Array, Boolean, Object],
            default: null
        },
        error: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            modalCreateSubCategory: false,
            nameSubcategory: ''
        }
    },
    computed: {
        localValue: {
            get() {
                if (this.component.type === 'number' || this.component.type === 'decimal') {
                    return this.modelValue === null || this.modelValue === undefined ? undefined : this.modelValue;
                }
                return this.modelValue;
            },
            set(value) {
                this.$emit('input', value === '' ? null : value);
            }
        }
    },
    methods: {
        ...mapActions('formBuilder', ['createSubCategory']),
        handleNumberChange(value) {
            this.$emit('input', value);
        },
        cancelSubCategory() {
            this.modalCreateSubCategory = false;
            this.nameSubcategory = '';
        },
        async saveSubCategory() {
            let subcategory = {
                name: this.nameSubcategory,
                form_category_id: this.component.properties.selectOptions
            }

            this.$validator.validateAll("formCreateSubcategory").then(async (result) => {
                if (result) {
                    let res = await this.createSubCategory(subcategory);
                    if (res) {
                        this.component.properties.options.push({
                            code: res.data.code,
                            id: res.data.id,
                            name: res.data.name
                        });
                        this.modalCreateSubCategory = false;
                        this.nameSubcategory = '';
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
.dynamic-field {
    width: 100%;
}

.form-control-custom {
    width: 100% !important;
    display: block;
}

.form-control-custom.el-input-number {
    width: 100% !important;
}

.form-control-custom.el-input-number .el-input__inner {
    text-align: left;
    padding-left: 15px;
}

:deep(.el-input__wrapper),
:deep(.el-select),
:deep(.el-date-editor),
:deep(.el-input-number__decrease),
:deep(.el-input-number__increase) {
    box-shadow: none !important;
}

:deep(.el-input__wrapper),
:deep(.el-select .el-input__wrapper),
:deep(.el-date-editor.el-input__wrapper),
:deep(.el-input-number .el-input__wrapper) {
    padding: 1px 11px;
}
</style>
